import React, { useCallback, useContext } from 'react';
import { DateField, FlexColumn, FormModal } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { getDirtyFields, required } from '@ubeya/shared/utils/form';
import styled from 'styled-components';
import moment from 'moment';
import { API_DATE_FORMAT } from '@ubeya/shared/constants';

const Container = styled(FlexColumn)`
  gap: 16px;
`;

const AdjustEmployeeContractStartDateModal = ({ onClose, adjustEmployeeContract, contract }) => {
  const { t } = useContext(ConfigContext);

  const initialValues = {
    startDate: contract.employeeStartDate
  };

  const onSubmit = useCallback(
    async (values, form) => {
      const { dirtyFields } = form.getState();
      const dirtyValues = getDirtyFields(values, dirtyFields);
      if (!dirtyValues) return;
      const { startDate } = dirtyValues;
      if (!startDate) return;

      const formattedDate = moment(startDate).format(API_DATE_FORMAT);

      await adjustEmployeeContract({
        startDate: formattedDate,
        employeeContractId: contract.employeeContractId
      });
      onClose();
    },
    [adjustEmployeeContract, contract.employeeContractId, onClose]
  );

  return (
    <FormModal
      initialValues={initialValues}
      onSubmit={onSubmit}
      size="small"
      onClose={onClose}
      title={t('contractTypes_employeeSpecificContractTerms')}
      confirmText={t('update')}
      showCancelButton>
      <Container>
        <DateField
          name="startDate"
          title={t('contractTypes_employeeContractStartingDate')}
          required
          validate={required}
          clearable={false}
          usePortal
        />
      </Container>
    </FormModal>
  );
};

export default AdjustEmployeeContractStartDateModal;
